import dayjs from "dayjs";

/* eslint-disable no-invalid-this */

/**
 * Yup `.test()` callback factory for "end date/time can't be before start date/time" —
 * drop-in replacement for the hand-rolled cross-field checks duplicated across the
 * event/timesheet forms (each written slightly differently). Use as the third argument
 * to `.test(name, message, ...)`.
 *
 * @param {string} startField - sibling field name read via Yup's `this.parent`
 * @param {object} [options]
 * @param {boolean} [options.allowEqual=true] - whether end === start passes
 */
export const endNotBeforeStart = (startField, { allowEqual = true } = {}) =>
  function endNotBeforeStartTest(value) {
    if (!value) return true;
    const startValue = this.parent?.[startField];
    if (!startValue) return true;
    const end = dayjs(value);
    const start = dayjs(startValue);
    if (!end.isValid() || !start.isValid()) return true;
    return allowEqual ? !end.isBefore(start) : end.isAfter(start);
  };
